export const getOrderIdByHash = (
  orders: Array<{ id: number; hash: string }> | undefined,
  orderHash: string,
): number | undefined => {
  if (!orders || !orderHash) return undefined;
  const order = orders.find((item) => item.hash === orderHash);

  return order?.id;
};
